// extracted by mini-css-extract-plugin
export default {"drawerBody":"DrawerBody-module__drawerBody__d8eb8ff37e9c0cd98f1c"};